import { NgIfContext } from '@angular/common';
import { Component, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { LanguageService } from 'src/app/services/language.service';
import { SpecialistsService } from 'src/app/services/v2/users/specialists.service';

@Component({
  selector: 'app-change-coach',
  templateUrl: './change-coach.component.html',
  styleUrl: './change-coach.component.scss'
})
export class ChangeCoachComponent {
  public readonly tmpImg = 'https://dakkini-api.s3.us-east-2.amazonaws.com/8hicic7x9d0kgnpokz7o5bpxzy4z?response-content-disposition=inline%3B%20filename%3D%22Foto%20Montse.jpg%22%3B%20filename%2A%3DUTF-8%27%27Foto%2520Montse.jpg&response-content-type=image%2Fjpeg&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIATOB6PK5SJH3DLDPB%2F20250630%2Fus-east-2%2Fs3%2Faws4_request&X-Amz-Date=20250630T205133Z&X-Amz-Expires=300&X-Amz-SignedHeaders=host&X-Amz-Signature=54692329681e08a03ce692ae691e4ca447c8c8384bf54322bc9d4e3acbf03260'
  protected locale: string = this.languageService.getLanguage();
  public specialists: Array<any> = [];
  public actualCoach: any = {};
  public loading: boolean = true;
  noTherapistsTemplate: TemplateRef<NgIfContext<number>>;
  loadingTemplate: TemplateRef<NgIfContext<boolean>>;
  constructor(private specialistsService: SpecialistsService,
    private languageService: LanguageService,
    private router: Router) { }

  ngOnInit(): void {
    this.getTherapists();
  }

  getTherapists() {
    this.loading = true;
    this.specialistsService.getCoachesToChange().subscribe((res) => {
      console.log(res)
      this.specialists = res.coaches;
      this.actualCoach = res.actual_coach;
      this.loading = false;
    })
  }


  changeCoach(coachId: string) {
    this.loading = true;
    this.specialistsService.changeCoach(coachId).subscribe({
      next: (res) => {
        this.router.navigate(['/'])
      }, 
      complete: () => {
        this.loading = false;
      },
      error: () => {
        this.loading = false;
        alert("Error to update. Contact support")
      }
    })
  }
}
